import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { createAction } from 'redux-actions';
import TierManageContent from '@wix/da-shared-react/pkg/Tier/TierManageContent';
import DeviationLink from '@wix/da-shared-react/pkg/Duperbrowse/DeviationLink';
import DeviationDuperbrowsableContext from '@wix/da-shared-react/pkg/Duperbrowse/DeviationDuperbrowseContext';
import Flex from '@wix/da-ds/pkg/Flex';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';

export interface Props {
  onSelect: (d) => void;
}

export const fetchUserTiers = createAction('@MS/FETCH_UT', () => ({}));
export const listLoaded = createAction('@MS/FETCH_UT_DONE', ({ list }) => ({
  list,
}));

const TempAssoc: React.FC<Props> = props => {
  const dispatch = useDispatch();
  const tiers: any = useSelector<AppState, any>(
    state => state?.subTempAssoc?.tiers
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!tiers && typeof window !== 'undefined') {
      dispatch(fetchUserTiers());
    }
  }, [dispatch, tiers]);

  const styles: React.CSSProperties = {
    position: 'absolute',
    top: '0px',
    right: '10px',
    width: '400px',
    height: '38px',
    background: 'white',
    border: '1px solid red',
    color: 'black',
    zIndex: 9999999999,
    overflowY: 'scroll',
  };

  if (show) {
    styles.height = '100px';
  }

  if (!tiers) {
    return null;
  }

  return (
    <div style={styles}>
      {!show && (
        <div onClick={() => setShow(true)}>Click To See Your Tiers</div>
      )}
      {show && tiers && Array.isArray(tiers) && (
        <DeviationDuperbrowsableContext streamId={'XXXX'} deviations={tiers}>
          {tiers.map(t => {
            return (
              <Flex style={{ padding: '4px' }} key={t.title}>
                {t.title}
                <TierManageContent type={'deviation'} tierDeviation={t} />
                <TierManageContent type={'post'} tierDeviation={t} />
                <GhostButton
                  variant={'edit-purple'}
                  size={'medium'}
                  onClick={() => props.onSelect(t)}
                >
                  Edit Tier
                </GhostButton>
                <DeviationLink deviation={t}>View</DeviationLink>
              </Flex>
            );
          })}
        </DeviationDuperbrowsableContext>
      )}
    </div>
  );
};
TempAssoc.displayName = 'TempAssoc';

export default TempAssoc;
